enum CampaignsTableColumns {
  CAMPAIGN_NAME = '__tree_data_group__',
  ADVERTISER = 'advertiserName',
  WHITELABEL = 'whitelabel',
  STATUS = 'status',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  LINE_ITEMS = 'lineItemsCount',
  CREATIVES = 'creativesCount',
  PACING_STATUS = 'pacingStatus',
  PACING_TO = 'pacingTo',
  BOOKED = 'booked',
  DELIVERED = 'delivered',
  LAST_UPDATED = 'updateDate',
  ALT_ID = 'altId',
  PLATFORM = 'platform',
}

export default CampaignsTableColumns;
